import React from "react";
import { motion } from "../components/StaticMotion";
import { HoverCard, HoverIcon } from "../components/HoverMotion";
import { Link } from "react-router-dom";
import { Button } from "@vionixasia/shared-components";
import {
  FaUserPlus,
  FaBoxOpen,
  FaHourglassEnd,
  FaAward,
  FaCamera,
  FaMapMarkedAlt,
  FaPaintBrush,
  FaUsers,
} from "react-icons/fa";
import { SERVICES } from "../data/services";

const ICON_MAP = {
  registration: <FaUserPlus className="w-5 h-5" />,
  racepack: <FaBoxOpen className="w-5 h-5" />,
  timing: <FaHourglassEnd className="w-5 h-5" />,
  results: <FaAward className="w-5 h-5" />,
  gallery: <FaCamera className="w-5 h-5" />,
  tracking: <FaMapMarkedAlt className="w-5 h-5" />,
  concept: <FaPaintBrush className="w-5 h-5" />,
  fulfilment: <FaUsers className="w-5 h-5" />,
};

const cardVariants = {
  hidden: { opacity: 0, y: 25, scale: 0.95 },
  visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.6, ease: "easeOut" } },
};

const containerVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.12, delayChildren: 0.2 } },
};

export const SectionWhatWeDo = () => {
  return (
    <section id="services" className="w-full py-16 lg:py-24 px-4 bg-white overflow-hidden">
      <motion.div
        className="w-full max-w-6xl mx-auto"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.6 }}
      >
        <div className="text-center mb-10">
          <motion.h2
            className="text-3xl md:text-4xl font-black text-gray-900 uppercase tracking-tight mb-3"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Our Services
          </motion.h2>
          <motion.p
            className="text-gray-600 max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            Eight integrated services that cover every aspect of your race — from first registration to final fulfilment.
          </motion.p>
        </div>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {SERVICES.map((service) => {
            const isDark =
              service.slug === "live-tracking-map" ||
              service.slug === "timing-system";
            return (
              <motion.div
                key={service.slug}
                variants={cardVariants}
              >
                <HoverCard
                  className={`p-4 h-full flex flex-col gap-4 rounded-card border border-slate-200 ${
                    isDark ? "bg-slate-900" : "bg-white"
                  }`}
                >
                  <HoverIcon
                    className={`w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-icon border ${
                      isDark
                        ? "bg-white/10 border-white/20 text-white"
                        : "bg-slate-100 border-slate-200 text-slate-700"
                    }`}
                  >
                    {ICON_MAP[service.icon]}
                  </HoverIcon>

                  <div className="flex-1">
                    <h3
                      className={`text-sm font-bold mb-1 leading-snug ${
                        isDark ? "text-white" : "text-slate-900"
                      }`}
                    >
                      {service.title}
                    </h3>
                    <p
                      className={`text-xs leading-relaxed ${
                        isDark ? "text-slate-400" : "text-slate-500"
                      }`}
                    >
                      {service.tagline}
                    </p>
                  </div>

                  <div className="mt-auto">
                    <Link to={`/services/${service.slug}`}>
                      <Button
                        variant={isDark ? "muted" : "secondary"}
                        color="slate"
                        fullWidth
                      >
                        Learn More →
                      </Button>
                    </Link>
                  </div>
                </HoverCard>
              </motion.div>
            );
          })}
        </motion.div>
      </motion.div>
    </section>
  );
};
